//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import RatingsList from "~/components/structure/RatingsList"
import RankingList from "~/components/ranking/RankingList.vue";

export default {
	name: "organisations-slug-parties",
	components: {
		RankingList,
	},
	props: {
		slug: {
			type: String,
			required: true,
		},
		organisation: {
			type: Object,
			required: true,
		},
		ranking: {
			type: Object,
			required: true,
		},
	},
	computed: {
		rankingList() {
			return this.$store.state.orderByDesc.ranking
				? this.ranking.ranking.parties
				: [...this.ranking.ranking.parties].reverse();
		},
		computedRanking() {
			return this.$store.state.filters.ranking.filters.canton.length === 0
				? this.ranking
				: this.ranking.parties
						.map((party) => {
							const res = {
								id: party.id,
								count: 0,
								score: 0,
								participated: 0,
							};
							this.$store.state.filters.ranking.filters.canton.forEach((canton) => {
								if (canton in party.cantons) {
									res.count++;
									res.score += party.cantons[canton].score;
									res.participated += party.cantons[canton].participated;
								}
							});
							if (res.count > 0) {
								res["percentage"] =
									Math.round(((res.score / res.participated) * 100 + Number.EPSILON) * 10000) / 10000;
							}
							return res;
						})
						.sort((a, b) => {
							return this.$store.state.orderByDesc.ranking
								? b.percentage - a.percentage
								: a.percentage - b.percentage;
						});
		},
	},
	methods: {
		getTitle(party) {
			return this.$store.getters.getPartyName(party.id);
		},
		getTags(e) {
			return this.$store.state.filters.ranking.filters.canton;
		},
		descString(party) {
			return this.$store.getters["rankings/getRankingDescParty"](party, this.organisation, this.$i18n.locale);
		},
		getImgUrl(e) {
			return `/ngo-logo-placeholder.png`;
		},
		getTo(party) {
			const path = this.localePath({
				name: "organisations-slug",
			});
			return `${path}?party=${party.id}`;
		},
	},
	nuxtI18n: {
		paths: {
			en: "/organisations/:slug/parties",
			de: "/organisationen/:slug/parteien",
			fr: "/organisations/:slug/partis",
			it: "/organizzazioni/:slug/partiti",
		},
	},
	head() {
		return {
			title: `${this.$t(`parties`)} – ${this.organisation.name} – VoteLog`,
		};
	},
};
